<template>
    <div class="card">
        <div class="table-responsive">
            <table class="table table-bordered nowrap">
                <thead>
                    <tr>
                        <th rowspan="2">Sl</th>
                        <th rowspan="2">Name of Consultant</th>
                        <th v-for="spec in specificationList" :key="spec.key" colspan="2" class="text-center">
                            {{ spec.label }}
                        </th>
                        <th colspan="2" class="text-center">Total</th>
                    </tr>
                    <tr>
                        <template v-for="spec in specificationList" :key="spec.key">
                            <th class="text-right">Count</th>
                            <th class="text-right">Amount</th>
                        </template>
                        <th class="text-right">Count</th>
                        <th class="text-right">Amount</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(child, childIndex) in props.reportList" :key="childIndex">
                        <td>{{ childIndex + 1 }}</td>
                        <td>{{ child.consultant_name }}</td>
                        <template v-for="spec in specificationList" :key="spec.key">
                            <td class="text-right">{{ child[spec.key + '_count'] }}</td>
                            <td class="text-right">{{ formatAmount(child[spec.key + '_amount']) }}</td>
                        </template>
                        <td class="text-right">{{ child.total_count }}</td>
                        <td class="text-right">{{ formatAmount(child.total_amount) }}</td>
                    </tr>
                    <tr>
                        <th colspan="2" class="text-right">Total</th>
                        <template v-for="spec in specificationList" :key="spec.key">
                            <th class="text-right">{{ columnSum(spec.key + '_count') }}</th>
                            <th class="text-right">{{ formatAmount(columnSum(spec.key + '_amount')) }}</th>
                        </template>
                        <th class="text-right">{{ columnSum('total_count') }}</th>
                        <th class="text-right">{{ formatAmount(columnSum('total_amount')) }}</th>
                    </tr>
                    <tr v-if="showSummary">
                        <th colspan="2" class="text-right">Grand Total</th>
                        <template v-for="spec in specificationList" :key="spec.key">
                            <th class="text-right">{{ summaryValue(spec.key + '_count') }}</th>
                            <th class="text-right">{{ formatAmount(summaryValue(spec.key + '_amount')) }}</th>
                        </template>
                        <th class="text-right">{{ summaryValue('total_count') }}</th>
                        <th class="text-right">{{ formatAmount(summaryValue('total_amount')) }}</th>
                    </tr>
                </tbody>
            </table>
          <p v-if="!props.reportList.length" class="text-center mt-5">No data</p>
        </div>
    </div>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
    reportList: Array,
    specifications: Object,
    summary: Object,
    isLastPage: {
        type: Boolean,
        default: true
    }
})

const specificationList = computed(() => {
    if (! props.specifications) return []
    return Object.keys(props.specifications).map((key) => {
        return { key: key, label: props.specifications[key] }
    })
})

const showSummary = computed(() => {
    if (! props.summary) return false
    if (! props.reportList.length) return false
    return props.isLastPage
})

const summaryValue = (field) => {
    if (! props.summary) return 0
    return Number(props.summary[field])
}

const columnSum = (field) => {
    return props.reportList.reduce((sum, child) => sum + Number(child[field]), 0)
}

const formatAmount = (amount) => {
    return Number(amount).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
}
</script>

<style scoped>
    .nowrap{
        white-space: nowrap;
    }
</style>
